import React from 'react'

function UserRoutes({ user, children }) {
  return (
    <>
      <div className='user-nav'>
        <div className='col-2 fw-bold brand'>Xebia</div>
        <div className='col-8 user-email text-end'>{user}</div>
      </div>
      <div className='user-wrapper px-2 py-3'>{children}</div>
      <footer className='user-footer'>
        <div className='brand ps-4 ps-md-2 ps-lg-2'>Xebia Group © 2021. All rights reserved.</div>
        <div className='links ps-3 ps-md-0 ps-lg-0'>
          <span className=' '>
            <a href='/' rel='noreferrer'>
              About
            </a>
          </span>
          <span className=' '>
            <a href='/' rel='noreferrer'>
              Contact Us
            </a>
          </span>
          <span className=' '>
            <a href='/' rel='noreferrer'>
              Privacy
            </a>
          </span>
          <span className=' '>
            <a href='/' rel='noreferrer'>
              Terms
            </a>
          </span>
        </div>
      </footer>
    </>
  )
}

export default UserRoutes
